import { useTranslation } from 'react-i18next';
import { SEOMeta } from '../components/SEOMeta';
import { FinalCTA } from "../components/sections/home";
import { CatalogueDemo, BrandShowcase, TechnicalIntegration } from "../components/sections/catalogue";
import { Button } from "../components/ui/Button";
import { RelatedPages } from '../components/RelatedPages';
import styles from "./Catalogue.module.css";

export function Catalogue() {
  const { t } = useTranslation('catalogue');

  return (
    <>
      <SEOMeta title={t('meta.title')} description={t('meta.description')} />

      <div className={styles.aboveFold}>
        <div className={styles.aboveFoldBg} />
        <div className={styles.heroZone}>
          <div className={styles.heroContent}>
            <h1>{t('hero.title')}</h1>
            <p className={styles.heroSubtitle}>{t('hero.subtitle')}</p>
            <div className={styles.heroCta}>
              <Button
                href="https://pro.quelbonplan.fr"
                variant="primary"
                className={styles.heroCtaButton}
              >
                {t('hero.ctaB2B')}
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="M7 17L17 7" />
                  <path d="M7 7h10v10" />
                </svg>
              </Button>
              <span className={styles.heroCtaHint}>{t('hero.ctaB2BHint')}</span>
            </div>
          </div>
        </div>
        <div className={styles.demoZone}>
          <CatalogueDemo />
        </div>
      </div>

      <BrandShowcase />
      <TechnicalIntegration />

      <RelatedPages currentFrPath="/catalogue" />
      <FinalCTA />
    </>
  );
}
